<script setup lang="ts">
import ReactiveLogo from '@/components/Assets/ReactiveLogo.vue'
import type { MenuItemType } from '@/types/MenuItem'
import { EVENTS_ROUTES } from '../../router/routes'
import MenuItem from './MenuItem.vue'

const item: MenuItemType = {
    to: EVENTS_ROUTES.baseUrl,
    label: ''
}
</script>

<template>
    <MenuItem :item="item" class="flex pointer home-logo">
        <template #label>
            <ReactiveLogo />
        </template>
    </MenuItem>
</template>

<style scoped lang="scss">
.home-logo {
    width: 100%;
    & :deep(li) {
        width: 100%;
        list-style: none;
        & a {
            place-content: center;
            &.is-active {
                background-color: transparent;
            }
            &:hover {
                background-color: transparent;
            }
        }
    }
}
</style>
